import React from 'react';
import { SubtitleDescription, Sentence } from '../../Typography';
import { mediaQueries } from '../../../style/breakpoints';
import colors from '../../../style/colors';

/**
 * @type React.FunctionComponent<{ title: string; text?: string; item?: array}>
 */

const OpportunityItem = ({ title, item }) => {
  return (
    <div css={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <div css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <SubtitleDescription
          css={{
            paddingBottom: 32,
            '&:before': {
              content: "''",
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: colors.yellow,
              display: 'inline-block',
              marginRight: 12,
              marginBottom: 1,
            },
          }}
        >
          {title}
        </SubtitleDescription>
      </div>

      <div
        css={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          [mediaQueries.phoneOnly]: {
            paddingBottom: 16,
          },
        }}
      >
        {item.map((item, i) => {
          return (
            <div
              key={i}
              css={{
                '&:not(:last-child)': {
                  marginBottom: 32,
                  marginRight: 15,
                },
              }}
            >
              <Sentence
                css={{
                  paddingBottom: 16,
                  marginBottom: 8,
                  borderBottom: '1px solid lightgrey',
                  [mediaQueries.phoneOnly]: {
                    paddingBottom: 8,
                  },
                }}
              >
                {item.name}
              </Sentence>
              <div
                css={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: 285,
                  justifyContent: 'space-between',
                  [mediaQueries.tabletPortraitUp]: {
                    width: 420,
                  },
                }}
              >
                <div>
                  <Sentence
                    css={{
                      textTransform: 'uppercase',
                      fontSize: 11,
                      letterSpacing: 0.7,
                      lineHeight: '17px',
                      [mediaQueries.phoneOnly]: {
                        fontSize: 11,
                      },
                    }}
                  >
                    {item.salary.paris.type}
                  </Sentence>
                  <Sentence
                    css={{
                      fontWeight: 'bold',
                      [mediaQueries.phoneOnly]: {
                        fontSize: 16,
                      },
                    }}
                  >
                    {item.salary.paris.value}
                  </Sentence>
                </div>
                <div>
                  <Sentence
                    css={{
                      textTransform: 'uppercase',
                      fontSize: 11,
                      letterSpacing: 0.7,
                      lineHeight: '17px',
                      [mediaQueries.phoneOnly]: {
                        fontSize: 11,
                      },
                    }}
                  >
                    {item.salary.metropoles ? item.salary.metropoles.type : null}
                  </Sentence>
                  <Sentence
                    css={{
                      fontWeight: 'bold',
                      [mediaQueries.phoneOnly]: {
                        fontSize: 16,
                      },
                    }}
                  >
                    {item.salary.metropoles ? item.salary.metropoles.value : null}
                  </Sentence>
                </div>
                {/*  */}
                <div>
                  <Sentence
                    css={{
                      textTransform: 'uppercase',
                      fontSize: 11,
                      letterSpacing: 0.7,
                      lineHeight: '17px',
                      [mediaQueries.phoneOnly]: {
                        fontSize: 11,
                      },
                    }}
                  >
                    {item.salary.regions ? item.salary.regions.type : null}
                  </Sentence>
                  <Sentence
                    css={{
                      fontWeight: 'bold',
                      [mediaQueries.phoneOnly]: {
                        fontSize: 16,
                      },
                    }}
                  >
                    {item.salary.regions ? item.salary.regions.value : null}
                  </Sentence>
                </div>
                {/*  */}
                <div>
                  <Sentence
                    css={{
                      textTransform: 'uppercase',
                      fontSize: 11,
                      letterSpacing: 0.7,
                      lineHeight: '17px',
                      [mediaQueries.phoneOnly]: {
                        fontSize: 11,
                      },
                    }}
                  >
                    {item.salary.opt ? item.salary.opt.type : null}
                  </Sentence>
                  <Sentence css={{ fontWeight: 'bold' }}>
                    {item.salary.opt ? item.salary.opt.value : null}
                  </Sentence>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OpportunityItem;
